<p>post-source-info works!</p>
